











import { defineComponent } from '@vue/composition-api';
import BaseH3 from '../base-headings/_base-h4.vue';
import BaseParagraph from '../base-paragraph/_base-paragraph.vue';

export default defineComponent({
  name: 'BaseEmptyState',
  components: {
    BaseH3,
    BaseParagraph,
  },
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    maxWidth: { type: Number, default: 30 },
  },
  setup() {
    return {};
  },
});
